import { Button, Descriptions, Dropdown, Icon, Menu, message, Modal, Popconfirm, Select, Table } from "antd";
import React, { useEffect, useState } from "react";
import { execQuery, getDocumentById } from "../../../../components/http.request";
import { toArray } from "../../../../business/utils";
import { ColumnProps } from "antd/lib/table";
import Confirm from "../../../../components/qa_custom/confirm";
import { MenuFormRender } from "../../../../V2/shared/FormHandler";
import { Utilitaries } from "../../../../business";
import { api_fetch } from "../../../../V2/utils/HttpRequest/request";
import { SelectAvatar } from "../../../../V2/components/FormRender/FormComponents/Avatar";

interface Cares {
    id: string;
    data: string;
    servico: string;
    id_cliente: string;
    nome: string;
    foto: string;
    valencia: string;
    estabelecimento: string;
    id_tipo_cuidado: string;
    tipo_cuidado: string;
    id_cuidado: string;
    cuidado: string;
    cuidado_descricao: string;
    apoio: string;
    prescricao: string;
    quantidade: string;
    hora_inicio: string;
    hora_fim: string;
    resultado: string;
    icone: string;
    resultado_obs: string;
    id_cuidado_plano: string;
    index: number;
    _loading: boolean;
}

interface CaresColumns {
    id?: string;
    nome: string;
    valencia: string;
    id_cliente: string;
    foto: string;
    data: string;
    cares: Cares[];
    cuidados_nao_planeados?: string;
    id_consumo?: string;
    recados?: string;
    alertas?: string;
    colaboradores?: string;
    load?: boolean;
}

interface ClientCares {
    [id: string]: CaresColumns;
}

interface ModalInfo {
    visible: boolean;
    title?: string;
    form?: string;
    formId?: string;
    params?: any;
    index?: number;
    client_id?: string;
}

interface Props {
    formItems: any;
    correctForm: boolean;
    currentTaskStatus: boolean;
    readonly: boolean;
}

interface Client {
    id_cliente: string;
    nome: string;
    foto: string;
}

export const SimplifiedPCIRegistryComponent = ({ formItems, correctForm, currentTaskStatus, readonly }: Props) => {
    const [clientsCares, setClientsCares] = useState<ClientCares>({});
    const [clients, setClients] = useState<Client[]>([]);
    const [iconsIds, setIconsIds] = useState<string[]>([]);
    const [iconsBase64, setIconsBase64] = useState<{ [key: string]: string }>({});
    const [loading, setLoading] = useState(false);
    const [selectedClient, setSelectedClient] = useState("");

    const [modalInfo, setModalInfo] = useState<ModalInfo>({ visible: false } as ModalInfo);

    const disabled = correctForm ? false : currentTaskStatus || readonly;

    useEffect(() => {
        loadIcons();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iconsIds]);

    const loadRegisteredCares = async () => {
        try {
            setLoading(true);
            const response = await execQuery({
                query: "scl_pci_registados",
                idProcesso: formItems?.processo?.value,
            });

            if (response && response.result) {
                const idIcons: string[] = [];

                const _clientsCares: ClientCares = (toArray(response.result) as any[]).reduce((acc, care) => {
                    if (!acc[care.id_cliente]) {
                        acc[care.id_cliente] = {
                            nome: care.nome,
                            valencia: care.valencia,
                            id_cliente: care.id_cliente,
                            data: care.data,
                            id: care.id,
                            foto: care.foto,
                            cuidados_nao_planeados: care.cuidados_nao_planeados,
                            recados: care.recados,
                            alertas: care.alertas,
                            id_consumo: care.id_consumo,
                            colaboradores: care.colaboradores,
                            cares: [],
                        };
                    }

                    if (care.icone && !idIcons.includes(care.icone)) {
                        idIcons.push(care.icone);
                    }

                    if (care.id_registo) {
                        acc[care.id_cliente].cares.push({
                            id: care.id_registo,
                            data: care.data,
                            servico: care.servico,
                            id_cliente: care.id_cliente,
                            nome: care.nome,
                            valencia: care.valencia,
                            estabelecimento: care.estabelecimento,
                            id_tipo_cuidado: care.id_tipo_cuidado,
                            tipo_cuidado: care.tipo_cuidado,
                            id_cuidado: care.id_cuidado,
                            cuidado: care.cuidado,
                            cuidado_descricao: care.cuidado_descricao,
                            apoio: care.apoio,
                            prescricao: care.prescricao,
                            quantidade: care.quantidade,
                            hora_inicio: care.hora_inicio,
                            hora_fim: care.hora_fim,
                            resultado: care.resultado,
                            icone: care.icone,
                            resultado_obs: care.resultado_obs,
                            id_cuidado_plano: care.id_cuidado_plano,
                            index: Utilitaries.toArray(acc[care.id_cliente].cares).length,
                        });
                    }

                    return acc;
                }, {} as ClientCares);

                Object.entries(_clientsCares).forEach(([key, values]) => {
                    const orderedCares = values.cares.sort((a, b) =>
                        a.cuidado_descricao.localeCompare(b.cuidado_descricao)
                    );

                    _clientsCares[key].cares = orderedCares;
                });

                setClientsCares(_clientsCares);
                setIconsIds(idIcons);
            } else {
                setClientsCares({});
            }
        } catch (error) {
            setClientsCares({});
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (formItems?.id_selecao_clientes_ci?.value) {
            loadRegisteredCares();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (formItems?.resposta_soc?.value) {
            handleLoadClients();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formItems?.resposta_soc?.value]);

    const handleLoadClients = async () => {
        try {
            const response = await execQuery({
                query: "clientes_admitidos_com_foto",
                idValencia: formItems?.resposta_soc?.value,
                idEstabelecimento: formItems?.estabelecimento?.value,
                grupo_cliente: formItems?.grupo_func?.value,
                clientes_na_instituicao: formItems?.cli_inst?.value
                    ? formItems?.cli_inst?.value === "t"
                        ? "true"
                        : "false"
                    : "",
            });

            if (response && response.result) {
                const _clientsCares = toArray(response.result);
                setClients(_clientsCares);
            } else {
                setClients([]);
            }
        } catch (error) {
            setClients([]);
        }
    };

    const handleLoadCares = async () => {
        try {
            setLoading(true);
            const response = await execQuery({
                query: "scl_pci_planeado_com_autorizacao",
                idValencia: formItems?.resposta_soc?.value,
                idEstabelecimento: formItems?.estabelecimento?.value,
                data_ini: formItems?.data?.value,
                data_fim: formItems?.data?.value,
                hora_ini: formItems?.hora_inis?.value,
                hora_fim: formItems?.hora_fins?.value,
                grupo_cliente: formItems?.grupo_func?.value,
                clientes_na_instituicao: formItems?.cli_inst?.value
                    ? formItems?.cli_inst?.value === "t"
                        ? "true"
                        : "false"
                    : "",
                servisos: String(formItems?.servicos_lista?.value).replace(/\s/g, "").replace(/,/g, " "),
            });

            if (response && response.result) {
                const idIcons: string[] = [];

                const listOfCares = (toArray(response.result) as Cares[]).reduce((acc, care) => {
                    if (!acc[care.id_cliente]) {
                        acc[care.id_cliente] = {
                            nome: care.nome,
                            foto: care.foto,
                            valencia: care.valencia,
                            id_cliente: care.id_cliente,
                            data: care.data,
                            cares: [],
                        };
                    }

                    if (care.icone && !idIcons.includes(care.icone)) {
                        idIcons.push(care.icone);
                    }

                    care.index = Utilitaries.toArray(acc[care.id_cliente].cares).length;
                    acc[care.id_cliente].cares.push(care);
                    return acc;
                }, {} as ClientCares);

                Object.entries(listOfCares).forEach(([key, values]) => {
                    const orderedCares = values.cares.sort((a, b) =>
                        a.cuidado_descricao.localeCompare(b.cuidado_descricao)
                    );

                    listOfCares[key].cares = orderedCares;
                });

                setClientsCares(listOfCares);
                setIconsIds(idIcons);
            } else {
                setClientsCares({});
            }
        } catch (error) {
            setClientsCares({});
        } finally {
            setLoading(false);
        }
    };

    const loadIcons = async () => {
        const iconsBase64 = await Promise.all(
            iconsIds.map(async (iconId) => {
                const iconBase64 = await getDocumentById(iconId);
                return { [iconId]: iconBase64 };
            })
        );

        // Converte o array de ícones para um objeto que mapeia id para base64
        const iconsBase64Object = iconsBase64.reduce((acc, icon) => ({ ...acc, ...icon }), {});

        // Atualiza o estado com todos os ícones carregados
        setIconsBase64(iconsBase64Object);
    };

    const handleCareOpenForm = (care: Cares, index: number) => {
        setModalInfo({
            visible: true,
            index: index,
            client_id: care.id_cliente,
            title: "Registar cuidado - " + care.cuidado_descricao,
            form: "scl_pci_registos.qml.xml",
            formId: care.id,
            params: {
                idProcesso: formItems?.processo?.value,
                idActividadeOrigem: formItems?.actividade?.value,
                idModelo: formItems?.actividade?.value,
                idModeloOrigem: formItems?.modelo?.value,
                idEstabelecimento: formItems?.estabelecimento?.value,
                idValencia: care.valencia,
                idCliente: care.id_cliente,
                servico: care.servico,
                data_c: care.data,
                cli_nome: care.nome,
                id_tipo_cuidado: care.id_tipo_cuidado,
                tipo_cuidado: care.tipo_cuidado,
                id_cuidado: care.id_cuidado,
                cuidado: care.cuidado,
                hora_ini: care.hora_inicio,
                hora_fim: care.hora_fim,
                id_cuidado_plano: care.id_cuidado_plano,
            },
        });
    };

    const handleDeleteCare = async (care: Cares) => {
        try {
            debugger;
            const newCares = clientsCares[care.id_cliente].cares.filter((c) => {
                if (
                    c.id_cuidado === care.id_cuidado &&
                    c.index === care.index &&
                    c.id_tipo_cuidado === care.id_tipo_cuidado &&
                    c.servico === care.servico
                ) {
                    return false;
                }

                return true;
            });

            const _clientsCares = {
                ...clientsCares,
                [care.id_cliente]: {
                    ...clientsCares[care.id_cliente],
                    cares: newCares,
                },
            };
            // _clientsCares[care.id_cliente].cares = newCares;

            setClientsCares(_clientsCares);
        } catch (error) {
            console.error("Error removing care:", error);
        }
    };

    const handleSaveCare = async (care: Cares) => {
        const _formData = {
            processo: formItems?.processo?.value,
            actividade_origem: formItems?.actividade?.value,
            modelo: formItems?.actividade?.value,
            modelo_origem: formItems?.modelo?.value,
            estabelecimento: formItems?.estabelecimento?.value,
            valencia: care.valencia,
            cliente: care.id_cliente,
            servico: care.servico,
            data_registo: care.data,
            dia_semana_registo: "",
            hora_ini: care.hora_inicio,
            hora_fim: care.hora_fim,
            nome_cliente: care.nome,
            sevico_nome: "",
            id_tipo_cuidado: care.id_tipo_cuidado,
            tipo_cuidado: care.tipo_cuidado,
            id_cuidado: care.id_cuidado,
            cuidado: care.cuidado,
            hora_exec: care.hora_inicio,
            duracao: "",
            resultado: care.resultado,
            quantidade: 1,
            id_cuidado_plano: care.id_cuidado_plano,
            observacoes: "",
        };

        const params = {        
            accao: "guardar",
            formulario: "scl_pci_registos.qml.xml",
            obrigatorios: false,
            dados: JSON.stringify({
                scl_pci_registos: _formData,
            }),
        };

        let _clientsCares = { ...clientsCares };
        _clientsCares = {
            ...clientsCares,
            [care.id_cliente]: {
                ...clientsCares[care.id_cliente],
                cares: _clientsCares[care.id_cliente].cares.map((c) => {
                    if (c.index === care.index) {
                        c._loading = true;
                    }
                    return c;
                }),
            },
        };
        setClientsCares(_clientsCares);

        const response = await api_fetch({
            endPoint: `Gestor/gereprocesso.php`,
            method: "POST",
            params,
        });

        _clientsCares = {
            ...clientsCares,
            [care.id_cliente]: {
                ...clientsCares[care.id_cliente],
                cares: _clientsCares[care.id_cliente].cares.map((c) => {
                    if (c.index === care.index) {
                        c._loading = false;
                    }
                    return c;
                }),
            },
        };

        if (response.status === "SUCCESS") {
            const resp = response.response;
            if (!resp || resp.sucesso === "0") {
                message.error("Ocorreu um erro");
            } else {
                message.success(`Cuidado ${care.cuidado_descricao} guardado com sucesso`);

                const newCares = _clientsCares[care.id_cliente].cares.map((c) => {
                    if (c.index === care.index) {
                        c.id = resp.sucesso;
                    }
                    return c;
                });

                _clientsCares = {
                    ...clientsCares,
                    [care.id_cliente]: {
                        ...clientsCares[care.id_cliente],
                        cares: newCares,
                    },
                };
            }
        } else if (response.status === "ERROR") {
            message.error(response.message || "Ocorreu um erro");
        }

        setClientsCares(_clientsCares);
    };

    const menu = ({ care }: { care: Cares }) => (
        <Menu>
            <Menu.Item key="1" onClick={() => handleSaveCare(care)}>
                Guardar
            </Menu.Item>
            <Menu.Item key="2" onClick={() => handleDeleteCare(care)}>
                Remover Cuidado
            </Menu.Item>
        </Menu>
    );

    const columns: ColumnProps<CaresColumns>[] = [
        {
            title: "Cliente",
            dataIndex: "nome",
            key: "nome",
            align: "left",
            width: "300px",
            render: (text, record) => (
                <div style={{ display: "flex", alignItems: "center" }}>
                    <SelectAvatar image={Utilitaries.toString(record.foto)} fromLabel size="default" />
                    {text}
                </div>
            ),
        },
        {
            title: "Serviços Planeados",
            key: "services_planead",
            align: "center",
            render: (text, record) => (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        alignContent: "flex-start",
                        justifyContent: "flex-start",
                        alignItems: "center",
                    }}
                >
                    {record.cares.map((care, index) => (
                        <div
                            style={{
                                padding: 8,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                            key={index}
                        >
                            <span>{care.cuidado_descricao}</span>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <Dropdown overlay={menu({ care })} trigger={["contextMenu"]}>
                                    <Button
                                        size="large"
                                        style={{ height: 64, width: 50, padding: 4 }}
                                        onClick={() => handleCareOpenForm(care, index)}
                                        loading={care._loading}
                                    >
                                        {care.icone ? (
                                            <img src={iconsBase64[care.icone]} alt="avatar" style={{ width: "100%" }} />
                                        ) : (
                                            <Icon type="smile" theme="twoTone" />
                                        )}
                                    </Button>
                                </Dropdown>
                                {!Utilitaries.isEmpty(care.id) && (
                                    <Icon
                                        style={{
                                            color: "green",
                                            marginLeft: 10,
                                            marginTop: 4,
                                        }}
                                        type="check"
                                    />
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            ),
        },
        {
            title: "Não Planeado",
            key: "nao_planeado",
            align: "center",
            width: "120px",
            render: (text, record) => (
                <div
                    style={{ display: "flex", justifyContent: "center", alignContent: "center", alignItems: "center" }}
                >
                    <Button
                        size="large"
                        type="link"
                        style={{ padding: 4 }}
                        onClick={() => {
                            debugger
                            setModalInfo({
                                visible: true,
                                title: "Registar cuidados não planeados",
                                form: "scl_pci_registos_nao_planeado.qml.xml",
                                client_id: record.id_cliente,
                                formId: record.cuidados_nao_planeados,
                                params: {
                                    idProcesso: formItems?.processo?.value,
                                    idActividadeOrigem: formItems?.actividade?.value,
                                    idModelo: formItems?.actividade?.value,
                                    idModeloOrigem: formItems?.modelo?.value,
                                    idEstabelecimento: formItems?.estabelecimento?.value,
                                    idValencia: record.valencia,
                                    idCliente: record.id_cliente,
                                    aspecto: "sim",
                                    aut: "1",
                                    servicos: String(formItems?.servicos_lista?.value)
                                        .replace(/\s/g, "")
                                        .replace(/,/g, " "),
                                    data_c: record.data,
                                    cli_nome: record.nome,
                                },
                            });
                        }}
                    >
                        <Icon style={{ fontSize: 20 }} type="edit" theme="twoTone" />
                    </Button>
                    {!Utilitaries.isEmpty(record.cuidados_nao_planeados) && (
                        <Icon
                            style={{
                                color: "green",
                                marginLeft: 5,
                            }}
                            type="check"
                        />
                    )}
                </div>
            ),
        },
        {
            title: "Consumos",
            key: "consumos",
            align: "center",
            width: "120px",
            render: (text, record) => (
                <div
                    style={{ display: "flex", justifyContent: "center", alignContent: "center", alignItems: "center" }}
                >
                    <Button
                        size="large"
                        type="link"
                        style={{ padding: 4 }}
                        onClick={() => {
                            setModalInfo({
                                visible: true,
                                title: "Registar consumos utilizados nos cuidados",
                                form: "stk_registo_consumo.qml.xml",
                                client_id: record.id_cliente,
                                formId: record.id_consumo,
                                params: {
                                    idProcesso: formItems?.processo?.value,
                                    idActividadeOrigem: formItems?.actividade?.value,
                                    idModeloOrigem: formItems?.modelo?.value,
                                    idModelo: formItems?.actividade?.value,
                                    idCliente: record.id_cliente,
                                    cli_nome: record.nome,
                                    idValencia: record.valencia,
                                    idEstabelecimento: formItems?.estabelecimento?.value,
                                },
                            });
                        }}
                    >
                        <Icon style={{ fontSize: 24, color: "#1890ff" }} type="shopping-cart" />
                    </Button>
                    {!Utilitaries.isEmpty(record.id_consumo) && (
                        <Icon
                            style={{
                                color: "green",
                                marginLeft: 5,
                            }}
                            type="check"
                        />
                    )}
                </div>
            ),
        },
        // {
        //     title: "Colaboradores",
        //     key: "colaboradores",
        //     align: "center",
        //     width: "90px",
        //     render: (text, record) => (
        //         <div
        //             style={{ display: "flex", justifyContent: "center", alignContent: "center", alignItems: "center" }}
        //         >
        //             <Button
        //                 size="large"
        //                 type="link"
        //                 style={{ padding: 4 }}
        //                 onClick={() => {
        //                     setModalInfo({
        //                         visible: true,
        //                         title: "Registar colaboradores que fizeram o serviço",
        //                         form: "scl_pci_registos_colaboradores.qml.xml",
        //                         client_id: record.id_cliente,
        //                         formId: record.colaboradores,
        //                         params: {
        //                             idProcesso: formItems?.processo?.value,
        //                             idActividadeOrigem: formItems?.actividade?.value,
        //                             idModelo: formItems?.actividade?.value,
        //                             idModeloOrigem: formItems?.modelo?.value,
        //                             idEstabelecimento: formItems?.estabelecimento?.value,
        //                             idValencia: record.valencia,
        //                             idCliente: record.id_cliente,
        //                             data_c: record.data,
        //                             cli_nome: record.nome,
        //                         },
        //                     });
        //                 }}
        //             >
        //                 <Icon style={{ fontSize: 20, color: "#1890ff" }} type="team" />
        //             </Button>
        //             {!Utilitaries.isEmpty(record.colaboradores) && (
        //                 <Icon
        //                     style={{
        //                         color: "green",
        //                         marginLeft: 5,
        //                     }}
        //                     type="check"
        //                 />
        //             )}
        //         </div>
        //     ),
        // },
        {
            title: "Recados",
            key: "recados",
            align: "center",
            width: "90px",
            render: (text, record) => (
                <div
                    style={{ display: "flex", justifyContent: "center", alignContent: "center", alignItems: "center" }}
                >
                    <Button
                        size="large"
                        type="link"
                        style={{ padding: 4 }}
                        onClick={() => {
                            setModalInfo({
                                visible: true,
                                title: "Registar recados para responsável do cliente",
                                form: "scl_pci_registos_recados.qml.xml",
                                client_id: record.id_cliente,
                                formId: record.recados,
                                params: {
                                    idProcesso: formItems?.processo?.value,
                                    idActividadeOrigem: formItems?.actividade?.value,
                                    idModelo: formItems?.actividade?.value,
                                    idModeloOrigem: formItems?.modelo?.value,
                                    idEstabelecimento: formItems?.estabelecimento?.value,
                                    idValencia: record.valencia,
                                    idCliente: record.id_cliente,
                                    data_c: record.data,
                                    cli_nome: record.nome,
                                },
                            });
                        }}
                    >
                        <Icon style={{ fontSize: 20 }} type="message" theme="twoTone" />
                    </Button>
                    {!Utilitaries.isEmpty(record.recados) && (
                        <Icon
                            style={{
                                color: "green",
                                marginLeft: 5,
                            }}
                            type="check"
                        />
                    )}
                </div>
            ),
        },
        {
            title: "Alertas",
            key: "alertas",
            align: "center",
            width: "90px",
            render: (text, record) => (
                <div
                    style={{ display: "flex", justifyContent: "center", alignContent: "center", alignItems: "center" }}
                >
                    <Button
                        size="large"
                        type="link"
                        style={{ padding: 4 }}
                        onClick={() => {
                            setModalInfo({
                                visible: true,
                                title: "Registar alertas/ocorrências para funcionários",
                                form: "scl_pci_registos_alertas.qml.xml",
                                client_id: record.id_cliente,
                                formId: record.alertas,
                                params: {
                                    idProcesso: formItems?.processo?.value,
                                    idActividadeOrigem: formItems?.actividade?.value,
                                    idModelo: formItems?.actividade?.value,
                                    idModeloOrigem: formItems?.modelo?.value,
                                    idEstabelecimento: formItems?.estabelecimento?.value,
                                    idValencia: record.valencia,
                                    idCliente: record.id_cliente,
                                    data_c: record.data,
                                    cli_nome: record.nome,
                                },
                            });
                        }}
                    >
                        <Icon style={{ fontSize: 20 }} type="warning" theme="twoTone" />
                    </Button>
                    {!Utilitaries.isEmpty(record.alertas) && (
                        <Icon
                            style={{
                                color: "green",
                                marginLeft: 5,
                            }}
                            type="check"
                        />
                    )}
                </div>
            ),
        },
        {
            title: "Guardar",
            key: "guardar",
            align: "center",
            width: "90px",
            render: (text, record) => (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Button
                        size="large"
                        type="link"
                        loading={record.load}
                        style={{ padding: 4 }}
                        disabled={disabled}
                        onClick={() => handleOnSave(record)}
                    >
                        <Icon style={{ fontSize: 20 }} type="save" theme="twoTone" />
                    </Button>

                    {!Utilitaries.isEmpty(record.id) && (
                        <Icon
                            style={{
                                color: "green",
                                marginLeft: 5,
                            }}
                            type="check"
                        />
                    )}

                    <Popconfirm
                        title="Tem certeza de que deseja remover este cliente dos registros?"
                        onConfirm={() => handleOnRemove(record)}
                        onCancel={() => {}}
                        okText="Sim"
                        cancelText="Cancelar"
                        style={{ marginLeft: 8 }}
                        disabled={disabled}
                    >
                        <Button size="large" type="link" disabled={disabled} style={{ padding: 4, marginLeft: 8 }}>
                            <Icon
                                title="Remover cliente"
                                style={{ fontSize: 20 }}
                                type="delete"
                                theme="twoTone"
                                twoToneColor="#f5222d"
                            />
                        </Button>
                    </Popconfirm>
                </div>
            ),
        },
    ];

    const handleOnSaveModal = async (value?: string) => {
        if (
            modalInfo.form === "scl_pci_registos.qml.xml" &&
            modalInfo.client_id &&
            modalInfo.index !== undefined &&
            !Utilitaries.isEmpty(value)
        ) {
            const _clientsCares = { ...clientsCares };

            _clientsCares[modalInfo.client_id].cares[modalInfo.index].id = value || "";

            const response = await execQuery({
                query: "scl_pci_resultado_imagem",
                id_resuldado: value,
            });

            if (response && response.result) {
                const iconId = Array.isArray(response.result) ? response.result[0].imagem : response.result.imagem;
                if (iconId) {
                    if (!iconsBase64[iconId]) {
                        const iconBase64 = await getDocumentById(iconId);
                        setIconsBase64({ ...iconsBase64, [iconId]: iconBase64 });
                    }
                    _clientsCares[modalInfo.client_id].cares[modalInfo.index].icone = iconId;
                }
            }

            setClientsCares(_clientsCares);
        } else if (modalInfo.form === "scl_pci_registos_nao_planeado.qml.xml" && modalInfo.client_id) {
            const _clientsCares = { ...clientsCares };

            _clientsCares[modalInfo.client_id].cuidados_nao_planeados = value || "";

            setClientsCares(_clientsCares);
        } else if (modalInfo.form === "stk_registo_consumo.qml.xml" && modalInfo.client_id) {
            const _clientsCares = { ...clientsCares };

            _clientsCares[modalInfo.client_id].id_consumo = value || "";

            setClientsCares(_clientsCares);
        } else if (modalInfo.form === "scl_pci_registos_alertas.qml.xml" && modalInfo.client_id) {
            const _clientsCares = { ...clientsCares };

            _clientsCares[modalInfo.client_id].alertas = value || "";

            setClientsCares(_clientsCares);
        } else if (modalInfo.form === "scl_pci_registos_recados.qml.xml" && modalInfo.client_id) {
            const _clientsCares = { ...clientsCares };

            _clientsCares[modalInfo.client_id].recados = value || "";

            setClientsCares(_clientsCares);
        } else if (modalInfo.form === "scl_pci_registos_colaboradores.qml.xml" && modalInfo.client_id) {
            const _clientsCares = { ...clientsCares };

            _clientsCares[modalInfo.client_id].colaboradores = value || "";

            setClientsCares(_clientsCares);
        }

        setModalInfo({ visible: false });
    };

    const handleOnSave = async (linha: CaresColumns) => {
        // salvar os cuidados se já não tiver sido feito individualmente
        const savedCares = linha.cares.map((care) => care.id);
        const hasSavedCares = savedCares.some((idCare) => !Utilitaries.isEmpty(idCare));

        if (!hasSavedCares) {
            await Promise.all(
                linha.cares.map(async (care) => {
                    await handleSaveCare(care);
                })
            );
        }

        const _formData: any = {
            processo: formItems?.processo?.value,
            actividade_origem: formItems?.actividade?.value,
            modelo: "1",
            modelo_origem: "1",
            estabelecimento: formItems?.estabelecimento?.value,
            valencia: linha.valencia,
            cliente: linha.id_cliente,
            data_registo: linha.data,
            cuidado_nao_planeado: linha.cuidados_nao_planeados,
            recado: linha.recados,
            alerta: linha.alertas,
            id_consumo: linha.id_consumo,
            colaboradores: linha.colaboradores,
            cuidados: {
                cuidado: linha.cares
                    .filter((care) => !Utilitaries.isEmpty(care.id))
                    .map((care) => {
                        const _care: any = { cuidado_pop: care.id };

                        if (care.id) {
                            _care.id_pci_registos_linha_cuidado = care.id;
                        }

                        return _care;
                    }),
            },
        };

        if (linha.id) {
            _formData.id_pci_registos_linha = linha.id;
        }

        const params = {
            accao: "guardar",
            formulario: "scl_pci_registos_linhas.qml.xml",
            obrigatorios: false,
            dados: JSON.stringify({
                scl_pci_registos_linhas: _formData,
            }),
        };

        let _clientsCares = { ...clientsCares };
        _clientsCares[linha.id_cliente].load = true;
        setClientsCares(_clientsCares);

        const response = await api_fetch({
            endPoint: `Gestor/gereprocesso.php`,
            method: "POST",
            params,
        });

        _clientsCares = {
            ..._clientsCares,
            [linha.id_cliente]: {
                ..._clientsCares[linha.id_cliente],
                load: false,
            },
        };

        if (response.status === "SUCCESS") {
            const resp = response.response;
            if (!resp || resp.sucesso === "0") {
                message.error("Ocorreu um erro");
            } else {
                message.success("Guardado com sucesso");

                _clientsCares[linha.id_cliente].id = resp.sucesso || "";
            }
        } else if (response.status === "ERROR") {
            message.error(response.message || "Ocorreu um erro");
        }

        setClientsCares(_clientsCares);
    };

    const handleOnRemove = async (line: CaresColumns) => {
        try {
            setLoading(true);
            if (line.id) {
                const response = await execQuery({
                    query: "scl_pci_registado_delete",
                    idRegisto: line.id,
                });

                if (response && response.result && Utilitaries.toArray(response.result)?.[0]?.eliminado === "t") {
                    const _clientsCares = { ...clientsCares };
                    delete _clientsCares[line.id_cliente];
                    setClientsCares(_clientsCares);
                } else {
                    message.error("Ocorreu um erro ao remover o cliente dos registos.");
                }
            } else {
                const _clientsCares = { ...clientsCares };
                delete _clientsCares[line.id_cliente];
                setClientsCares(_clientsCares);
            }
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };

    const onCancelModal = () => {
        Confirm(() => {
            setModalInfo({ visible: false });
            // TODO: Salvar dados do cliente
        });
    };

    const handleAddClient = () => {
        const client = clients.find((client) => client.id_cliente === selectedClient);

        if (client) {
            const _clientsCares = { ...clientsCares };

            if (_clientsCares[client.id_cliente]) {
                message.info("Cliente já adicionado.");
                return;
            }

            _clientsCares[client.id_cliente] = {
                id_cliente: client.id_cliente,
                nome: client.nome,
                foto: client.foto,
                data: formItems?.data?.value, //new Date().toISOString().split("T")[0],
                valencia: formItems?.resposta_soc?.value,
                cares: [],
            };

            setClientsCares(_clientsCares);

            message.success("Cliente adicionado com sucesso");
        } else {
            message.error("Cliente não encontrado.");
        }
    };

    return (
        <>
            <Descriptions layout="vertical" column={2}>
                <Descriptions.Item label="Clientes planeados">
                    <Button icon="reload" disabled={disabled} onClick={handleLoadCares} loading={loading}>
                        Carregar cuidados planeados
                    </Button>
                </Descriptions.Item>
                <Descriptions.Item label="Clientes não planeados">
                    <Select
                        showSearch
                        style={{ width: 400, marginRight: 10 }}
                        placeholder="Selecione o cliente"
                        optionFilterProp="children"
                        onChange={(value) => {
                            setSelectedClient(value.toString());
                        }}
                        filterOption={(input, option) =>
                            Utilitaries.toString(option.props?.children)?.toLowerCase()?.indexOf(input.toLowerCase()) >=
                            0
                        }
                        disabled={disabled}
                    >
                        {clients.map((client) => (
                            <Select.Option key={client.id_cliente} value={client.id_cliente}>{client.nome}</Select.Option>
                        ))}
                    </Select>
                    <Button icon="plus" disabled={disabled} onClick={handleAddClient}>
                        Adicionar Cliente
                    </Button>
                </Descriptions.Item>
            </Descriptions>

            <Table
                columns={columns}
                pagination={{
                    defaultPageSize: 10,
                    showTotal: (total) => `Total registos: ${total}`,
                    showSizeChanger: true,
                }}
                rowKey={record => record.id_cliente}
                dataSource={Object.values(clientsCares).sort((a, b) => a.nome.localeCompare(b.nome))}
                loading={loading}
                style={{ marginBottom: 16, marginTop: 16 }}
            />
            <Modal
                title={modalInfo.title ?? "Formulário"}
                visible={modalInfo.visible}
                onOk={() => {}}
                destroyOnClose
                onCancel={onCancelModal}
                width="80%"
                footer={null}
            >
                <MenuFormRender
                    form_name={modalInfo.form}
                    popup_params={modalInfo.params}
                    form_id={modalInfo.formId}
                    onSave={handleOnSaveModal}
                    justSee={disabled}
                    isInModal={true}
                />
            </Modal>
        </>
    );
};
